export * from "modules/DMSv3/Capabilities/components/DMSCapabilitiesTable/components/FieldLabel";
export * from "modules/DMSv3/Capabilities/components/DMSCapabilitiesTable/components/SupportIcon";
